<footer class="appfooter">
  <div class="appfooter-inner">
    <div class="appfooter-grid">
      <!-- Brand -->
      <div class="appfooter-brand">
        <ls-logo size="sm" href="/" class="appfooter-logo" />
        <p class="tag">{{ 'FOOTER.TAGLINE' | translate }}</p>
        <app-lang-picker />
      </div>

      <!-- Découvrir -->
      <div class="appfooter-col">
        <h5>{{ 'FOOTER.DISCOVER.TITLE' | translate }}</h5>
        <ul>
          <li><a [routerLink]="['/', getLangValue(), routeName.Discover]">{{ 'FOOTER.DISCOVER.ALL_SONGS' | translate }}</a></li>
          <li><a [routerLink]="['/', getLangValue(), routeName.Genres]">{{ 'FOOTER.DISCOVER.GENRES' | translate }}</a></li>
          <li><a [routerLink]="['/', getLangValue(), routeName.Recueils]">{{ 'FOOTER.DISCOVER.RECUEILS' | translate }}</a></li>
          <li><a [routerLink]="['/', getLangValue(), routeName.Artistes]">{{ 'FOOTER.DISCOVER.ARTISTS' | translate }}</a></li>
        </ul>
      </div>

      <!-- Fonctionnalités -->
      <div class="appfooter-col">
        <h5>{{ 'FOOTER.FEATURES.TITLE' | translate }}</h5>
        <ul>
          <li>
            <a [routerLink]="['/', getLangValue(), 'karaoke']"
              >{{ 'FOOTER.FEATURES.KARAOKE' | translate }} <span class="pip">{{ 'FOOTER.FEATURES.BETA' | translate }}</span></a
            >
          </li>
          <li><a [routerLink]="['/', getLangValue(), 'projection']">{{ 'FOOTER.FEATURES.PROJECTION' | translate }}</a></li>
          <li><a [routerLink]="['/', getLangValue(), 'contribution']">{{ 'FOOTER.FEATURES.CONTRIBUTE' | translate }}</a></li>
          <li><a [routerLink]="['/', getLangValue(), 'premium']">{{ 'FOOTER.FEATURES.PREMIUM' | translate }}</a></li>
        </ul>
      </div>

      <!-- Compte -->
      <div class="appfooter-col">
        <h5>{{ 'FOOTER.ACCOUNT.TITLE' | translate }}</h5>
        <ul>
          @if (!authService.isAuthenticated()) {
            <li><a [routerLink]="['/', getLangValue(), 'connexion']">{{ 'FOOTER.ACCOUNT.LOGIN' | translate }}</a></li>
            <li><a [routerLink]="['/', getLangValue(), 'inscription']">{{ 'FOOTER.ACCOUNT.SIGNUP' | translate }}</a></li>
          }
          <li><a [routerLink]="['/', getLangValue(), routeName.MyProfil]">{{ 'FOOTER.ACCOUNT.PROFILE' | translate }}</a></li>
          <li><a [routerLink]="['/', getLangValue(), routeName.MySettings]">{{ 'FOOTER.ACCOUNT.SETTINGS' | translate }}</a></li>
        </ul>
      </div>

      <!-- Légal -->
      <div class="appfooter-col">
        <h5>{{ 'FOOTER.LEGAL.TITLE' | translate }}</h5>
        <ul>
          <li>
            <a [routerLink]="['/', getLangValue(), routeName.Conditions]">
              {{ 'FOOTER.LEGAL.TERMS' | translate }}
            </a>
          </li>
          <li>
            <a [routerLink]="['/', getLangValue(), routeName.Confidentialite]">{{ 'FOOTER.LEGAL.PRIVACY' | translate }}</a>
          </li>
          @if (consent.enabled) {
            <li>
              <button type="button" class="appfooter-linkbtn" (click)="consent.reopen()">{{ 'FOOTER.LEGAL.COOKIES' | translate }}</button>
            </li>
          }
        </ul>
      </div>
    </div>

    <!-- Bottom bar -->
    <div class="appfooter-bottom">
      <span class="copy">
        &copy; 2015 - {{year}}  <b>{{env.appName}}</b>
        @if (!env.production) {
          <span style="color:red; font-size: 0.5rem;"> {{env.name}}</span>.
        }
      </span>
      <span class="ver">{{env.version}}</span>
      <div class="legal">
        <a [routerLink]="['/', getLangValue(), routeName.Conditions]">{{ 'FOOTER.BOTTOM.TERMS_SHORT' | translate }}</a>
        <a [routerLink]="['/', getLangValue(), routeName.Confidentialite]">{{ 'FOOTER.BOTTOM.PRIVACY' | translate }}</a>
        <a href="https://chant.rezo509.com" target="_blank" rel="noopener noreferrer"
           [title]="'FOOTER.BOTTOM.OLD_VERSION_TITLE' | translate">{{ 'FOOTER.BOTTOM.OLD_VERSION' | translate }}</a>
      </div>
    </div>
  </div>
</footer>
